export default {"src":"/_next/static/media/azuro.625042b9.svg","height":318,"width":318,"blurWidth":0,"blurHeight":0};